abstract class Breakpoint {
	abstract get id(): string;
}

export default Breakpoint;
